import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress, Box } from '@mui/material';

import MainHeader from './header/mainheader';
import routes from './routes/routes';
import api, { setErrorHandler } from './api/api';
import { setUserDetails } from './redux/userSlice';
import Restricted from './utils/restrictions';
import { useError } from './utils/errorprovider';
import { sidebarListItems } from './utils/sidebarList';

export const publicRoutes = [
  '/', '/ntact/', '/ntact', '/ntact/reports/', '/reports', '/test',
  '/ntact/report/', '/report', '/ntact/forms/', '/forms',
  '/safety-form','/ntact/safety-form','/bbs-form','/ntact/bbs-form',
  '/driver-form','/ntact/driver-form','/accident-form','/ntact/accident-form','/enroll','/print'
];
const userroute=[
  "/profile",
  "/safety-analytics",
  "/landing",
  "/main",
  "/supervisor",
  "/weekly",
  "/timesheet",
  "/merge-dashboard",
  '/manual-dashboard'
  ,'/doc'
]

function App() {
  const [loading, setLoading] = useState(true);
  const userDetails = useSelector((state) => state.user.userDetails);
  const dispatch = useDispatch();
  const { showError } = useError();

  useEffect(() => {
    setErrorHandler(showError);
  }, [showError]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!publicRoutes.includes(window.location.pathname) && !userDetails) {
          const response = await api.get('/auth/me');
          dispatch(setUserDetails(response));
        }
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!userDetails) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [dispatch, userDetails]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Router basename="/">
      <div className="App bg-[#FFFFFF]">
        <DynamicHeader />
      <Routes>
{routes.map(({ path, component }) => {
  const isPublic = publicRoutes.includes(path);
  const isUserRoute = userroute.includes(path); // ✅ Check if this is a "user route"
  let allowed = isPublic;

  // Only check permissions if not public
  if (!isPublic && userDetails) {
    if (isUserRoute) {
      allowed = true; // ✅ Just having user is enough
    } else {
      const userPermissions = userDetails?.user_info?.permissions || [];
      const routeItem = sidebarListItems(null).find(item => item.path === path);

      console.log("Checking route:", path);
      console.log("User permissions:", userPermissions);
      console.log("Route id:", routeItem?.id);

      if (routeItem) {
        allowed = userPermissions.includes(routeItem.id.toString());
      }
      console.log("Allowed?", allowed);
    }
  }

  return (
    <Route
      key={path}
      path={path}
      element={allowed ? component : <Restricted />}
    />
  );
})}

</Routes>

      </div>
    </Router>
  );
}

function DynamicHeader() {
  const location = useLocation();
  const currentRoute = routes.find(route =>
   route.path === location.pathname);
  return currentRoute?.showHeader ? <MainHeader /> : null;
}

export default App;
